import { Route, Routes } from 'react-router-dom';

import Index from '../pages';
import Registrations from '../pages/registration';
import Create from '../pages/registration/create';

export function Registration() {
  return (
    <Routes>
      <Route path='/' element={<Index child={<Registrations />}/>} />
      <Route path='/create' element={<Index child={<Create />} />} />
    </Routes>
  );
}
